<div *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="carga" [titulo]="titulo" [efecto]="true" [colapseName]="'carga'"
    [banderaColapse]='true'>
  </app-lfsa-card>
  <ng-template #carga>
    <form [formGroup]="formulario" novalidate class="form-group">
      <div class="row">
        <div class="form-group col-md-4">
          <app-lfsa-combo-box-mult [mostrarImg]="false" [multiple]="false" [rutaImagen]=""
            (enviarOjeto)="obtenerObjetoDistribuidor($event)" [placeholder]="'Distribuidor'"
            [opcion]="modelDistribuidorMantenedor.descripcion" [idOpcion]="modelDistribuidorMantenedor.idDistribuidor"
            [comboBox]="cmbDistribuidor" [class]="'letrasDanger'" [label]="'Seleccione Distribuidor*'"
            [id]="'Distribuidor'">
          </app-lfsa-combo-box-mult>
        </div>
        <div class="form-group col-md-4">
          <!-- <img *ngIf="true" [src]="csv" height="35" width="35" alt="">&nbsp; -->
          <label for="csvInput" class="letrasDanger">ArchivoCSV.csv*</label>
          <input type="file" class="form-control-file" id="csvInput" (change)="onFileSelect($event)" #fileInput
            accept=".csv" />
        </div>
        <div class="form-group col-md-4">
          <label for="">&nbsp;</label>
          <button [disabled]="formulario.invalid" (click)="enviarFormulario()"
            class="zatras btn btn-success btn-block">Enviar</button>
        </div>
      </div>
    </form>
    <br>
    <div class="row">
      <ag-grid-angular [floatingFilter]="true" *ngIf="!listaVaciaCli" class="{{distribuidorModulo.agGrid.class}}"
        #agGrid [ngStyle]="distribuidorModulo.agGrid.style" id="{{distribuidorModulo.agGrid.id}}"
        [paginationPageSize]="distribuidorModulo.agGrid.paginacion" [pagination]="true"
        [frameworkComponents]="frameworkComponentsCli" [columnDefs]="columnDefsCli" [rowSelection]="rowSelectionCli"
        [rowData]="rowDataCli" (gridReady)="onGridReadyCli($event)">
      </ag-grid-angular>
    </div>
    <br>
    <br>
    <br>
  </ng-template>
  <!-- <div class="row">
    <div class="form-group col-md-12">
      <div *ngIf="formulario.invalid" class="zatras alert alert-danger" role="alert">
        <b> Complete la información solicitada, luego se habilitara el botón...!!! </b>
      </div>
    </div>
  </div> -->
  <!-- <app-loading *ngIf="loading"></app-loading>
  <div class="row" *ngIf="!loading">
    <div class="form-group col-md-6">
      <button [routerLink]="['/distribuidor/home']"
        class="zatras btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
    <div class="form-group col-md-6">
      <button [disabled]="formulario.invalid" (click)="enviarFormulario()"
        class="zatras btn btn-success btn-block btn-lg">Enviar</button>
    </div>
  </div> -->
</div>

<div *ngIf="mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'CARGAR DE ARCHIVO'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #grid>
    <!-- <div class="row">
      <div class="col-sm-12">
        <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
          (keyup)="onQuickFilterChanged()" #quickFilter />
      </div>
    </div> -->
    <div class="alert alert-danger" role="alert" *ngIf="listaVacia">
      No existen datos para la lista.
    </div>
    <br>
    <ag-grid-angular [floatingFilter]="true" class="{{distribuidorModulo.agGrid.class}}" #agGrid
      [ngStyle]="distribuidorModulo.agGrid.style" id="{{distribuidorModulo.agGrid.id}}"
      [paginationPageSize]="distribuidorModulo.agGrid.paginacion" [pagination]="true"
      [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs" [rowSelection]="rowSelection"
      [rowData]="rowData" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </ng-template>
  <div class="row">
    <div class="form-group col-md-6">
      <button (click)="regresar()" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
    <div class="form-group col-md-6">
      <button [disabled]="!errorData" (click)="guardar()"
        class="btn btn-outline-success btn-block btn-lg">Guardar</button>
    </div>
  </div>
  <br>
  <br>
</div>

<!-- MODAL -->
<app-lfsa-modal [innTemplate]="abrirModalMuiltiples" [titulo]="'visualización'" [idButton]="'abrirModal'"
  [idOpen]="'ModalMultiple'" [idClose]="'cerrarModalMultiple'"></app-lfsa-modal>
<ng-template #abrirModalMuiltiples>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6">
        <b>
          <h5>Razón Solcial:</h5>
        </b> {{ dataDistribuidor.razonSocial }}
      </div>
      <div class="col-md-6">
        <b>
          <h5>TipoDocu:</h5>
        </b> {{ dataDistribuidor.tipoDocumento }}
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-4">
        <b>
          <h5>Cliente:</h5>
        </b> {{ dataDistribuidor.nombreCliente }}
      </div>
      <div class="col-md-4">
        <b>
          <h5>Comercial:</h5>
        </b> {{ dataDistribuidor.nombreComercial }}
      </div>
      <div class="col-md-4">
        <b>
          <h5>C.I:</h5>
        </b> {{ dataDistribuidor.numeroIdentidad }}
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-4">
        <b>
          <h5>Cod.Distr:</h5>
        </b> {{ dataDistribuidor.codigoDistribuidor }}
      </div>
      <div class="col-md-4">
        <b>
          <h5>Cod.Fabril:</h5>
        </b> {{ dataDistribuidor.codigoFabril }}
      </div>
      <div class="col-md-4">
        <b>
          <h5>Cod.Vendedor:</h5>
        </b> {{ dataDistribuidor.codigoVendedorAsignado }}
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-4">
        <b>
          <h5>Correo1:</h5>
        </b> {{ dataDistribuidor.correoElectronico1 }}
      </div>
      <div class="col-md-4">
        <b>
          <h5>Correo2:</h5>
        </b> {{ dataDistribuidor.correoElectronico2 }}
      </div>
      <div class="col-md-4">
        <b>
          <h5>Estado:</h5>
        </b> {{ dataDistribuidor.estadoEnDistribuidor }}
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-3">
        <b>
          <h5>Telefono1:</h5>
        </b> {{ dataDistribuidor.telefonoCelular1 }}
      </div>
      <div class="col-md-3">
        <b>
          <h5>Telefono2:</h5>
        </b> {{ dataDistribuidor.telefonoCelular2 }}
      </div>
      <div class="col-md-3">
        <b>
          <h5>Tel.Fijo1:</h5>
        </b> {{ dataDistribuidor.telefonoFijo1 }}
      </div>
      <div class="col-md-3">
        <b>
          <h5>Tel.Fijo2:</h5>
        </b> {{ dataDistribuidor.telefonoFijo2 }}
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-4">
        <b>
          <h5>Provincia:</h5>
        </b> {{ dataDistribuidor.provincia }}
      </div>
      <div class="col-md-4">
        <b>
          <h5>Canton:</h5>
        </b> {{ dataDistribuidor.canton }}
      </div>
      <!-- <div class="col-md-3">
        <b>
          <h5>Ciudad:</h5>
        </b> {{ dataDistribuidor.ciudad }}
      </div> -->
      <div class="col-md-4">
        <b>
          <h5>Parroquia:</h5>
        </b> {{ dataDistribuidor.parroquia }}
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-6">
        <b>
          <h5>Long:</h5>
        </b> {{ dataDistribuidor.longitud }}
      </div>
      <div class="col-md-6">
        <b>
          <h5>Lat:</h5>
        </b> {{ dataDistribuidor.latitud }}
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-6">
        <b>
          <h5>Dirección:</h5>
        </b> {{ dataDistribuidor.direccion }}
      </div>
      <div class="col-md-6">
        <b>
          <h5>Referencia:</h5>
        </b> {{ dataDistribuidor.referenciaDireccion }}
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-6">
        <b>
          <h5>Regional:</h5>
        </b> {{ dataDistribuidor.regional }}
      </div>
      <div class="col-md-6">
        <b>
          <h5>Tier:</h5>
        </b> {{ dataDistribuidor.tier }}
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col">
        <div class="d-flex justify-content-center">
          <b>
            <h5>Imagen:</h5>
          </b><br>
          <img center [src]="dataDistribuidor.imagenes" [alt]="dataDistribuidor.imagenes" height="300" width="300">
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- END MODAL -->
